import {
  Model,
} from '@vuex-orm/core';

export default class extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'site'

  // List of all fields (schema) of the site model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields() {
    return {
      id: this.number(0),
      name: this.string(''),
      slug: this.string(''),
      type: this.string(''),
      extra: this.attr({}),
    };
  }

  static methodConf = {
    http: {
      url: '/api/spawner',
    },
    methods: {
      $fetch: {
        name: 'fetch',
        http: {
          url: '/sites',
          method: 'get',
        },
      },
      $get: {
        name: 'get',
        http: {
          url: '/sites/:id',
          method: 'get',
        },
      },
      $create: {
        name: 'create',
        http: {
          url: '/sites',
          method: 'site',
        },
      },
      $update: {
        name: 'update',
        http: {
          url: '/sites/:id',
          method: 'put',
        },
      },
      $delete: {
        name: 'delete',
        http: {
          url: '/sites/:id',
          method: 'delete',
        },
      },
    },
  }
}
